import { render, staticRenderFns } from "./mainProject.vue?vue&type=template&id=358e0902&scoped=true&"
import script from "./mainProject.vue?vue&type=script&lang=js&"
export * from "./mainProject.vue?vue&type=script&lang=js&"
import style0 from "./mainProject.vue?vue&type=style&index=0&id=358e0902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358e0902",
  null
  
)

export default component.exports